import { Grid } from '@material-ui/core';
import { Colors } from 'library';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { client, consoleLogInDev } from 'shared';
import { calculatePostAdded } from './dateUtils';
import { PostModel } from './NewsfeedModels';
import Post from './Posts/Post';

export default function PostAndCommentThread({ post }: { post?: PostModel }) {
    const [viewPost, setViewPost] = useState<PostModel>();
    const location = useLocation();

    useEffect(getPost, [location]);

    function getPost() {
        if (post) {
            return setViewPost(post);
        }
        let postId = new URLSearchParams(location.search).get('post');
        client(`api/post/${postId}`)
            .then((post: PostModel) => {
                post['postAge'] = calculatePostAdded(post.added_at);
                setViewPost(post);
            })
            .catch(consoleLogInDev);
    }

    return (
        <Grid
            style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                flexGrow: 1,
                paddingTop: 100,
                paddingRight: 5,
                paddingLeft: 5,
                paddingBottom: 10,
                backgroundColor: Colors.lightGrey,
            }}
        >
            {viewPost !== undefined ? (
                <Grid xs={12} style={{ maxWidth: 550, width: '100%', borderRadius: 25, backgroundColor: '#fff' }}>
                    <Grid style={{ margin: 25 }}>
                        <Post post={viewPost} commentsExpanded={true} />
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
}
